export default __webpack_public_path__ + "_/images/app/android/android-en-2-dfa005aaecd353430203317a0318c239bf3afeb8ffa30e75a4d84ad96c3b875a.png";